<template>
    <div class="row">
        <main class="col-sm-8">
            <div class="container">
                <!--Personal-->
                <div class="row  divider mb-3">
                    <div class="col">
                        <h4 @click="active_section=1" class="pointer mb-2"><i class="fa fa-user"></i>
                            {{translate('personal')}} <i v-if="ready1" class="fa fa-check text-success ml-2"></i></h4>
                        <transition name="smooth">
                            <div v-show="active_section==1" class="section">
                                <div class="form-group">
                                    <label for="inputName" class="required">{{translate('name')}}</label>
                                    <input type="text" v-model="personal.name" class="form-control" :class="{'is-invalid': !validateName}"

                                           id="inputName" aria-describedby="helpName" :placeholder="translate('name')" >
                                    <small id="helpName" class="form-text text-muted">
                                    </small>
                                </div>
                                <div class="form-group">
                                    <label for="inputPhone" class="required">{{translate('phone')}}</label>
                                    <input type="text" v-model="personal.phone" class="form-control"
                                           :class="{'is-invalid': !validatePhone}"
                                           id="inputPhone" aria-describedby="helpPhone"
                                           :placeholder="translate('phone')"
                                           autocomplete="off-your"
                                           @focus="mask"
                                           @input="mask"
                                           @blur="mask"
                                           @keydown="mask"
                                    >
                                    <small id="helpPhone" class="form-text text-muted">
                                    </small>
                                </div>
                                <div class="form-group">
                                    <label for="inputEmail" class="required0">{{translate('email')}}</label>
                                    <input type="email" v-model="personal.email" class="form-control"
                                           :class="{'is-invalid': !validateEmail}"
                                           id="inputEmail" aria-describedby="emailHelp"
                                           :placeholder="translate('email')">
                                    <small id="emailHelp" class="form-text text-muted"></small>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <!--Delivery-->
                <div class="row divider mb-3">
                    <div class="col">
                        <h4 @click="active_section=2" class="pointer mb-2"><i class="fa fa-truck"></i>
                            {{translate('delivery')}} <i v-if="ready2" class="fa fa-check text-success ml-2"></i></h4>
                        <transition name="smooth">
                            <div  class="section">
                                <!--City-->
                                <div class="form-group">
                                    <label for="inputAddress" class="required">{{translate('address')}}</label>
                                    <div class="address_selector">
                                        <input type="text"
                                               :value='address'
                                               :class="{'is-invalid': !ready2}"
                                               @input='evt=>address=evt.target.value'
                                               @keyup.esc="addressClear"
                                               autocomplete="off-me"
                                               @keyup="addressSelect"
                                               @focus="addressSelectStart" class="form-control"
                                               id="inputAddress" aria-describedby="helpAddress"
                                               :placeholder="translate('address')">
                                        <div class="clear text-danger" @click="addressClear">X</div>
                                        <ul v-if="addressSelectorActive">
                                            <li v-for="(adr,index) in addresses" @click="addressSelected(index)">
                                                {{adr.Present}}
                                            </li>
                                        </ul>
                                    </div>
                                    <small id="helpAddress" class="form-text text-muted"></small>
                                </div>
                                <!--Delivery Method-->
                                <div v-if="city">
                                    <h5 class="mb-2">{{translate('delivery_method')}}</h5>
                                    <div class="form-group pl-4">
                                        <div class="form-check" v-for="(item,index) in deliveryOptions">
                                            <div v-if="!item.need_kyiv || (item.need_kyiv && city.Area==='Київська')">
                                                <input class="form-check-input" type="radio" name="deliveryRadios"
                                                       :id="'deliveryRadios_'+index" :value=index
                                                       v-model="delivery.deliveryMethod"
                                                       @change="deliveryClear">
                                                <label class="form-check-label" :for="'deliveryRadios_'+index">
                                                    {{item[lang('title')]}}
                                                </label>
                                                <div class="form-group" v-if="delivery.deliveryMethod==index">
                                                    <!--Address-->
                                                    <div class="form-row" v-if="item.need_address">
                                                        <div class="form-group col-md-8">
                                                            <!--Street-->
                                                            <label for="delivery_kyiv_street">
                                                                {{translate('delivery_street')}}
                                                            </label>
                                                            <div class="office_selector">
                                                                <input type="text"
                                                                       :class="{'is-invalid': !ready2}"
                                                                       :value='delivery.deliveryStreet'
                                                                       @input='evt=>{delivery.deliveryStreet=evt.target.value;streetSelect()}'
                                                                       class="form-control"
                                                                       id="delivery_kyiv_street"
                                                                       aria-describedby="helpStreet"
                                                                       @focus="streetsSelectStart"
                                                                       autocomplete="off"

                                                                       @keyup.esc="streetClear"

                                                                       :placeholder="translate('delivery_street')">
                                                                <div class="clear text-danger"
                                                                     @click="delivery.deliveryStreet=''">x
                                                                </div>
                                                                <ul v-if="streetSelectorActive">
                                                                    <li v-for="(adr,index) in streets"
                                                                        @click="streetSelected(index)">
                                                                        {{adr.Present}}
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>

                                                        <div class="form-group col-md-2">
                                                            <label for="delivery_kyiv_build" class="required">
                                                                {{translate('delivery_build')}}
                                                            </label>
                                                            <input type="text" id="delivery_kyiv_build"
                                                                   class="form-control"
                                                                   :class="{'is-invalid': !ready2}"
                                                                   v-model="delivery.deliveryBuild"
                                                                   :placeholder="translate('delivery_build')">
                                                        </div>
                                                        <div class="form-group col-md-2">
                                                            <label for="delivery_kyiv_apartment">
                                                                {{translate('delivery_apartment')}}
                                                            </label>
                                                            <input type="text" id="delivery_kyiv_apartment"
                                                                   class="form-control"
                                                                   :class="{'is-invalid': !ready2}"
                                                                   v-model="delivery.deliveryApartment"
                                                                   :placeholder="translate('delivery_apartment')">
                                                        </div>
                                                    </div>

                                                    <div class="form-row" v-if="item.need_address_detail">
                                                        <!--Entrance-->
                                                        <div class="form-group col-md-2">
                                                            <label for="delivery_entrance">
                                                                {{translate('delivery_entrance')}}
                                                            </label>
                                                            <input type="text" id="delivery_entrance"
                                                                   class="form-control"
                                                                   :class="{'is-invalid': !ready2}"
                                                                   v-model="delivery.deliveryEntrance"
                                                                   :placeholder="translate('delivery_entrance')">
                                                        </div>
                                                        <!--Floor-->
                                                        <div class="form-group col-md-2">
                                                            <label for="delivery_floor">
                                                                {{translate('delivery_floor')}}
                                                            </label>
                                                            <input type="text" id="delivery_floor"
                                                                   class="form-control"
                                                                   v-model="delivery.deliveryFloor"
                                                                   :placeholder="translate('delivery_floor')">
                                                        </div>
                                                        <!--Elevator-->
                                                        <div class="form-group col-md-8">
                                                            <label for="delivery_elevator" class="ml-md-1">
                                                                {{translate('delivery_elevator')}}
                                                            </label>
                                                            <select class="custom-select form-control"
                                                                    id="delivery_elevator"
                                                                    v-model="delivery.deliveryElevator">
                                                                <option value="none">
                                                                    {{translate('delivery_elevator_none')}}
                                                                </option>
                                                                <option value="passenger">
                                                                    {{translate('delivery_elevator_passenger')}}
                                                                </option>
                                                                <option value="freight">
                                                                    {{translate('delivery_elevator_freight')}}
                                                                </option>
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <!--Office-->
                                                    <div class="form-group" v-if="item.need_office">

                                                        <label for="inputOffice" class="required ">{{translate('delivery_np_select_office')}}</label>
                                                        <div class="office_selector">
                                                            <input type="text" v-model="delivery.deliveryOffice"
                                                                   class="form-control"
                                                                   id="inputOffice" aria-describedby="helpOffice"
                                                                   :class="{'is-invalid': !ready2}"
                                                                   @focus="officeSelectorActive=true"
                                                                   autocomplete="off"
                                                                   :placeholder="translate('delivery_np_select_office')">
                                                            <div class="clear text-danger" @click="officeClear">x
                                                            </div>
                                                            <ul v-if="officeSelectorActive">
                                                                <li v-for="(adr,index) in filtered_offices"
                                                                    @click="officeSelected(adr)">
                                                                    {{adr.Description}}
                                                                </li>
                                                            </ul>
                                                        </div>

                                                    </div>
                                                    <small id="helpName1" class="form-text text-muted"></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
                <!--Payment-->
                <div class="row divider mb-3">
                    <div class="col">
                        <h4 @click="active_section=3" class="pointer mb-2"><i class="fa fa-credit-card"></i>
                            {{translate('payment')}} <i v-if="ready3" class="fa fa-check text-success ml-2"></i>
                        </h4>
                        <transition name="smooth">
                            <div  class="section">
                                <div class="form-group pl-4">
                                    <div v-for="(payment,index) in payments">
                                        <div class="form-check">
                                            <input class="form-check-input pointer" type="radio" name="payment_method"
                                                   :id="'payment_'+index" :value="index"
                                                   v-model="result.payment_method">
                                            <label class="form-check-label" :for="'payment_'+index">
                                                {{payment[lang('title')]}}
                                            </label>
                                            <div v-show="payment.banks && result.payment_method==index" class="section">
                                                <div v-for="(bank,index) in payment.banks">
                                                    <template v-if="bank.limit === null || bank.limit>cart.total">
                                                        <label class="custom-input--radio pointer">
                                                            <input type="radio" class="item__type" name="creditProgram"
                                                                   :value="index" v-model="result.credit_program">
                                                            <span class="custom-input__state"></span>
                                                            <span class="custom-input__name">
                                                            <img :src="bank.logo"
                                                                 class="ml-3 d-inline">
                                                            <span>
                                                                <span class="item__bank-name">{{bank[lang('title')]}}</span>
                                                                <span class="item__program-name">{{bank[lang('conditions')]}}</span>
                                                             </span>
                                                        </span>
                                                        </label>
                                                        <a href="#" class="ml-3" data-toggle="collapse"
                                                           :data-target="'#collapse_'+index"
                                                           aria-expanded="false" :aria-controls="'collapse_'+index">
                                                            <i class="fa fa-question-circle"></i>
                                                        </a>
                                                        <div class="collapse mb-2" :id="'collapse_'+index">
                                                            <div class="card card-body">{{bank.description}}
                                                            </div>
                                                        </div>
                                                    </template>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </main>
        <aside class="col-sm-4">

            <div class="card">
                <div class="card-body">
                    <!--                    <p class="alert alert-success">Тут можна щось написати. </p>-->
                    <div class="mb-2">
                        <h4 class="text-center mb-2">{{translate('orderList')}}:</h4>

                        <!--                        <div v-if="checkout.cart" class="row" >-->
                        <div v-if="cart" class="card p-2">
                            <div class="row" v-for="product in cart.products">
                                <div class="col-3">
                                    <img :alt="product.name"
                                         :src="'/images/products/medium_'+product.id+'.jpg'"
                                         width="40">
                                </div>
                                <div class="col-9">
                                    <h5>{{product.name}}</h5>
                                    <p>{{product.qty}}x{{product.price}}грн.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <dl class="dlist-align">
                        <dt>{{translate('qty')}}:</dt>
                        <dd class="text-right">{{cart.count}}</dd>
                    </dl>
                    <dl class="dlist-align">
                        <dt>{{translate('subtotal')}}:</dt>
                        <dd class="text-right"><strong>{{cart.total}} грн.</strong></dd>
                    </dl>
<!--                    <dl class="dlist-align">-->
<!--                        <dt>{{translate('discount')}}:</dt>-->
<!--                        <dd class="text-right text-danger">- $10.00</dd>-->
<!--                    </dl>-->
<!--                    <dl class="dlist-align">-->
<!--                        <dt class="h6">{{translate('total')}}:</dt>-->
<!--                        <dd class="text-right text-dark b"><strong>{{cart.total}} грн.</strong></dd>-->
<!--                    </dl>-->
                    <hr>
                    <p class="text-center mb-3">
<!--                        <img src="/img/payments.png" height="26">-->
                    </p>
                    <div>
                        <div v-if="ready1">
                            <h5>{{translate('personal')}}</h5>
                            <p v-html="personalInfo"></p>
                        </div>
                        <div v-if="ready2">
                            <h5>{{translate('delivery')}}</h5>
                            <p v-html="deliverylInfo"></p>
                        </div>
                        <div v-if="ready3">
                            <h5>{{translate('payment')}}</h5>
                            <p v-html="paymentInfo"></p>
                        </div>
                    </div>

                        <a href="#" v-if="ready"  class="btn btn-primary btn-block" :class="{disabled:!ready}"
                                @click.prevent="finish">
                            <i v-if="isLoading" class="fas fa-spinner fa-spin"></i>
                            {{translate('checkout_confirm')}}

                        </a>
                        <a href="#" v-else class="btn btn-light btn-block " :class="{disabled:!ready}"
                                @click.prevent="finish"
                           >{{translate('checkout_confirm')}}</a>


                    <!--                    <a :href="previousUrl" class="btn btn-light btn-block">Продовжити покупки</a>-->
                </div> <!-- card-body.// -->
            </div> <!-- card.// -->
        </aside>

    </div>
</template>

<script>

    export default {
        name: "Checkout",
        components: {},
        props: ['locale'],

        data() {
            return {
                isLoading:false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                url: '/checkout',
                previousUrl: '/',
                cart: {},

                personal: {
                    name: '',
                    phone: '',
                    email: '',
                },

                delivery: {
                    deliveryMethod: null,
                    deliveryCity: null,
                    deliveryStreet: null,
                    deliveryBuild: null,
                    deliveryApartment: null,
                    deliveryOffice: null,
                    deliveryEntrance: null,
                    deliveryFloor: null,
                    deliveryElevator: "none",

                },
                result: {

                    payment_method: null,
                    credit_program: null,

                },

                active_section: 1,


                deliveryOptions: {},
                payments: {},
                city: null,

                address: '',
                addresses: [],
                addressSelectorActive: false,
                offices: [],
                officeSelectorActive: false,
                street: '',
                streets: [],
                streetSelectorActive: true,
                trans: {
                    'orderList': {
                        'ru': 'Ваш заказ ',
                        'uk': "Ваше замовлення",
                    },
                    'personal': {
                        'ru': 'Ваши данные ',
                        'uk': "Вашi дані",
                    },
                    'delivery': {
                        'ru': 'Доставка ',
                        'uk': "Доставка ",
                    },
                    'payment': {
                        'ru': 'Оплата ',
                        'uk': "Оплата",
                    },

                    'name': {'ru': 'Имя и фамилия ', 'uk': "Ім'я та прізвище",},
                    'phone': {'ru': 'Ваш номер телефона ', 'uk': "Ваш номер телефону",},
                    'email': {'ru': 'Електронная почта ', 'uk': "Електронна пошта",},

                    'address': {'ru': 'Введите населенный пункт ', 'uk': "Введіть населений пункт",},
                    'delivery_method': {'ru': 'Способ доставки ', 'uk': "Спосіб доставки",},
                    'delivery_method_kiev': {'ru': 'Доставка курьером по Киеву', 'uk': "Доставка кур'єром по Києву",},
                    'delivery_method_pickup': {'ru': 'Самовывоз', 'uk': "Самовивіз",},
                    'delivery_method_np': {
                        'ru': 'Доставка в отделение Новой почты ',
                        'uk': "Доставка у відділення Нової пошти",
                    },
                    'delivery_method_npk': {
                        'ru': 'Доставка курьером Новой почты',
                        'uk': "Доставка кур'єром Нової пошти",
                    },
                    'delivery_np_select_office': {'ru': 'Введите номер отделение', 'uk': "Введіть номер відділення",},
                    'delivery_street': {'ru': 'Улица', 'uk': "Вулиця",},
                    'delivery_build': {'ru': 'Дом', 'uk': "Будинок",},
                    'delivery_apartment': {'ru': 'Квартира', 'uk': "Квартира",},
                    'delivery_entrance': {'ru': 'Подъезд', 'uk': "Під'їзд",},
                    'delivery_floor': {'ru': 'Этаж', 'uk': "Поверх",},
                    'delivery_elevator': {'ru': 'Наличие лифта', 'uk': "Наявність ліфта",},
                    'delivery_elevator_none': {'ru': 'Нет', 'uk': "Нема",},
                    'delivery_elevator_passenger': {'ru': 'Пассажирский', 'uk': "Пасажирський",},
                    'delivery_elevator_freight': {'ru': 'Грузовой', 'uk': "Вантажний",},

                    'payment_method': {'ru': 'Способ оплаты', 'uk': "Спосіб оплати",},
                    'checkout_confirm': {'ru': 'Подтвердить заказ', 'uk': "Підтвердити замовлення",},

                    'qty': {
                        'ru': 'Товаров',
                        'uk': 'Товарів',
                    },
                    'subtotal': {
                        'ru': 'На сумму',
                        'uk': 'На суму',
                    },
                    'discount': {
                        'ru': 'Скидка',
                        'uk': 'Знижка',
                    },
                    'total': {
                        'ru': 'Всего',
                        'uk': 'Загалом',
                    },
                }
            }
        },
        mounted() {
            this.getCheckout();
            console.clear();
        },
        methods: {
            translate(sentence) {
                return this.trans[sentence][this.locale];
            },
            lang(value) {
                return value + "_" + this.locale;
            },
            mask(event) {
                var keyCode;

                event.keyCode && (keyCode = event.keyCode);

                var pos = event.target.selectionStart;
                if (pos < 5) event.preventDefault();
                var matrix = "+38 (0__) ___ ____",
                    i = 0,
                    def = matrix.replace(/\D/g, ""),
                    val = event.target.value.replace(/\D/g, ""),
                    new_value = matrix.replace(/[_\d]/g, function (a) {
                        return i < val.length ? val.charAt(i++) || def.charAt(i) : a
                    });
                i = new_value.indexOf("_");
                if (i != -1) {
                    i < 6 && (i = 5);
                    new_value = new_value.slice(0, i)
                }
                var reg = matrix.substr(0, event.target.value.length).replace(/_+/g,
                    function (a) {
                        return "\\d{1," + a.length + "}"
                    }).replace(/[+()]/g, "\\$&");
                reg = new RegExp("^" + reg + "$");
                if (!reg.test(event.target.value) || event.target.value.length < 6 || keyCode > 47 && keyCode < 58) event.target.value = new_value;
                if (event.type == "blur" && event.target.value.length < 6) event.target.value = ""
            },
            getCheckout() {
                axios
                    .post(this.url + '/getData', {action: 'get'})
                    .then(response => {
                        // this.checkout = response.data.checkout;
                        this.cart = response.data.cart;
                        // this.previousUrl = response.data.previousUrl;
                        this.payments = response.data.payments;
                        this.deliveryOptions = response.data.deliveryOptions;
                    })
                    .catch();
            },
            finish(event) {
                // console.log(event.target.form);
                if (this.isLoading){
                    return;
                }
                this.isLoading = true;
                this.result.personal = this.personal;
                this.result.delivery = this.delivery;

                axios.post(this.url + '/confirm', {checkout: this.result})
                    .then(response=>{
                        window.location = response.data;
                    });
            },
            deliveryClear() {

                // this.delivery.DeliveryOffice = null;
                this.officeSelectorActive = false;
                // this.office = '';
                // this.street = '';
                // this.delivery.DeliveryStreet = null;
                // this.build = '';
                // this.apartment = '';
            },
            addressSelectStart() {
                this.addressClear();
                this.addressSelectorActive = true;
                // this.delivery.DeliveryOffice = null;
                this.officeSelectorActive = false;
                this.office = '';
                this.offices = [];
                this.street = '';
                this.streets = [];
                // this.delivery.DeliveryStreet = null;
                this.build = '';
                this.apartment = '';
                this.delivery.deliveryMethod = null;
                // this.delivery.DeliveryMethod = 0;

            },
            addressSelect() {
                if (this.address.length < 1) {
                    return;
                }
                axios
                    .post(this.url + '/findCities', {city: this.address})
                    .then(response => {
                        // console.log(response.data);
                        if (response.data.data[0]) {
                            this.addresses = response.data.data[0].Addresses
                        }

                    })
                    .catch();
            },
            addressSelected(index) {
                this.address = this.addresses[index].Present;
                this.city = this.addresses[index];
                this.delivery.deliveryCity = this.addresses[index].Present;
                this.addressSelectorActive = false;
                // this.delivery.DeliveryOffice = null;
                this.office = '';
                this.officeSelectorActive = false;
                this.officeSelect();
                this.street = '';
                this.streets = [];
                // this.delivery.DeliveryStreet = null;
                this.delivery.deliveryMethod = null;
                // this.delivery.DeliveryMethod = 0;
            },
            addressClear() {
                this.addresses = [];
                this.address = '';
                this.addressSelectorActive = false;
            },
            officeSelect() {
                this.delivery.deliveryOffice = null;
                // this.office = '';
                axios
                    .post(this.url + '/findOffices', {office: this.city.DeliveryCity})
                    .then(response => {
                        // console.log(response.data.data);
                        if (response.data.data) {
                            this.offices = response.data.data;
                            this.officeSelectorActive = true;
                        }

                    })
                    .catch();
            },

            officeSelected(office) {
                this.delivery.deliveryOffice = office.Description;
                this.officeSelectorActive = false;

                this.delivery.deliveryStreet = null;
                this.delivery.deliveryBuild = null;
                this.delivery.deliveryApartment = null;

                // this.office = office.Description;
                // this.office = this.delivery.DeliveryOffice.Description;
                // this.delivery.DeliveryMethod = 2;
                // this.delivery.DeliveryStreet = null;
                // this.street = '';
                // this.build = '';
                // this.apartment = '';
            },
            officeClear() {
                this.delivery.deliveryOffice = null;
            },
            streetsSelectStart() {
                this.streetClear();
                this.streetSelectorActive = true;
            },
            streetClear() {
                this.streets = [];
                // this.result.delivery.deliveryStreet = '';
                this.streetSelectorActive = false;
            },
            streetSelect() {

                if (!this.delivery.deliveryStreet) {
                    return;
                }
                axios
                    .post(this.url + '/findStreets', {city: this.city.Ref, street: this.delivery.deliveryStreet})
                    .then(response => {
                        if (response.data.data[0]) {
                            this.streets = response.data.data[0].Addresses
                        }

                    })
                    .catch();
            },
            streetSelected(index) {
                this.delivery.deliveryStreet = this.streets[index].Present;
                this.streetSelectorActive = false;
                // this.result.delivery.DeliveryMethod = 3;
                this.delivery.deliveryOffice = null;
                // this.office = '';
            },
        },
        computed: {
            filtered_offices() {
                if (!this.delivery.deliveryOffice) {
                    return this.offices;
                }
                let that = this;
                return this.offices.filter(function (office) {
                    return office.Number.toString().toLowerCase().includes(that.delivery.deliveryOffice.toString().toLowerCase());
                });
            },
            personalInfo() {
                return this.personal.name + "<br>" + this.personal.phone + "<br>" + this.personal.email;
            },
            deliverylInfo() {
                let info = "";
                info += this.delivery.deliveryCity + "<br>";
                info += this.deliveryOptions[this.delivery.deliveryMethod][this.lang('title')] + "<br>";
                if (this.deliveryOptions[this.delivery.deliveryMethod].need_office) {
                    info += this.delivery.deliveryOffice;
                }
                if (this.deliveryOptions[this.delivery.deliveryMethod].need_address) {
                    info += this.delivery.deliveryStreet + "," + this.delivery.deliveryBuild;
                    if (this.delivery.deliveryApartment) {
                        info += ", кв." + this.delivery.deliveryApartment;
                    }
                    if (this.delivery.deliveryEntrance) {
                        info += ", "+this.translate('delivery_entrance')+":" + this.delivery.deliveryEntrance;
                    }
                    if (this.delivery.deliveryFloor) {
                        info += ", "+this.translate('delivery_floor')+":" +  this.delivery.deliveryFloor;
                    }
                    if (this.delivery.deliveryElevator !=='none') {
                        info += ", "+this.translate('delivery_elevator')+":" +  this.delivery.deliveryElevator;
                    }
                }
                return info;
            },
            paymentInfo() {
                let info = "";

                info += this.payments[this.result.payment_method][this.lang('title')] + "<br> ";
                if (this.payments[this.result.payment_method].banks) {
                    info += this.payments[this.result.payment_method].banks[this.result.credit_program][this.lang('title')];
                    info += " <i>(" + this.payments[this.result.payment_method].banks[this.result.credit_program][this.lang('conditions')] + ") <\i>";
                }

                return info;
            },

            ready1() {
                return this.validateName && this.validateEmail && this.validatePhone;
            },
            ready2() {
                return this.delivery.deliveryMethod
                    && (this.readyOffice || this.readyAddr || this.readyNone);
            },

            readyAddr() {
                let method = this.deliveryOptions[this.delivery.deliveryMethod];
                return method && method.need_address && this.delivery.deliveryStreet && this.delivery.deliveryBuild && true;
            },
            readyOffice() {
                let method = this.deliveryOptions[this.delivery.deliveryMethod];
                return method && method.need_office && this.delivery.deliveryOffice && true;
            },
            readyNone() {
                let method = this.deliveryOptions[this.delivery.deliveryMethod];
                return method && !method.need_office && !method.need_address && true;
            },

            ready3() {
                return this.result.payment_method && (this.result.payment_method != "credit" || (this.result.payment_method == 'credit' && this.result.credit_program));
            },

            ready() {
                return this.ready1 && this.ready2 && this.ready3;
            },

            validateName() {
                return this.personal.name.length > 3;
            },
            validateEmail() {
                if (!this.personal.email){
                    return true;
                }
                const regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return regex.test(this.personal.email);
            },
            validatePhone() {
                const regex = /^(\+38\s\(0)[0-9]{2}\)\s[0-9]{3}\s[0-9]{4}$/;
                return regex.test(this.personal.phone);
            },
        },

    }

</script>

<style scoped>
    .invert {
        filter: invert(1) hue-rotate(180deg);
    }

    .pointer {
        cursor: pointer;
    }

    .divider {
        border-left: 1px solid #0e8ce4;
    }

    label.required::after {
        content: '*';
        color: red;
    }

    .form-control {
        color: black;
    }

    [class*="dlist-"] {
        margin-bottom: 5px;
    }

    .dlist-align dt {
        width: 90px;
        float: left;
        word-wrap: break-word;
    }

    .itemside img {
        -o-object-fit: contain;
        object-fit: contain;
    }

    .section {
        max-height: 800px;
    }

    .smooth-enter-active, .smooth-leave-active {
        transition: max-height .5s;
        overflow: hidden;
    }

    .smooth-enter, .smooth-leave-to {
        transition: max-height .5s;
        max-height: 0;
    }


    select option {
        font-size: small;
    }

    input {
        color: black;
    }

    .address_selector input, .office_selector input {
        position: relative;
        color: black;
    }

    .address_selector .clear, .office_selector .clear {
        position: absolute;
        top: 6px;
        right: 9px;
        cursor: pointer;
    }

    .address_selector ul, .office_selector ul {
        position: absolute;
        border: 1px solid #d4d4d4;
        border-bottom: none;
        border-top: none;
        z-index: 99;
        top: 100%;
        left: 0;
        right: 0;
        box-shadow: 0px 5px 20px rgba(0, 0, 0, 0.1);
        max-height: 200px;
        overflow-y: auto;
        background-color: white;
    }

    .office_selector ul {
        max-height: 200px;
        overflow-y: auto;
    }

    .address_selector li, .office_selector li {
        padding: 10px;
        cursor: pointer;
        background-color: #fff;
        border-bottom: 1px solid #d4d4d4;
        color: gray;
    }

    .address_selector li:hover, .office_selector li:hover {
        color: black;
    }

    .item__program-name {
        font-style: italic;
    }
</style>
